import { Container, FormControlLabel, Grid, Radio } from "@mui/material";
import React, { useState } from "react";
import { UiNavBar } from "../../component/_uiComponents/UiNavbar";
import { UiDashboardWrapper } from "../../component/_uiComponents/UiDashboardWrapper";
import { UiDashboardContent } from "../../component/_uiComponents/UiDashboardContent";
import { UiSideBar } from "../../component/_uiComponents/UiSidebar";
import { UiTab } from "../../component/common/UiTab";
import { TabPanel } from "@mui/lab";
import { UiDashboardAvailableBalanceCard } from "../../component/_uiComponents/UiDashboardAvailableBalanceCard";
import { UiWhiteCard } from "../../component/common/UiWhiteCard";
import { UiNotificationCard } from "../../component/common/UiNotificationCard";
import {
  UiButton,
  UiIconButton,
  UiTextIconButton,
} from "../../component/common/UiButton";
import { CloseIcon } from "../../../../styles/img/svg/CloseIcon";
import { TransferIcon } from "../../../../styles/img/svg/TransferIcon";
import { BillIcon } from "../../../../styles/img/svg/BillIcon";
import { SettleCardIcon } from "../../../../styles/img/svg/SettleCardIcon";
import { UiFavouriteItem } from "../../component/common/UiFavouriteItem";
import DialogLogo from "../../../../styles/img/dialog-logo.png";
import Alogo from "../../../../styles/img/A-logo.png";
import { BookmarkIcon } from "../../../../styles/img/svg/BookmarkIcon";
import { UiActivities } from "../../component/_uiComponents/UiActivities";
import { UiSelectAccount } from "../../component/_uiComponents/UiSelectAccount";
import { UiNotificationCardWrapper } from "../../component/_uiComponents/UiNotificationCardWrapper";
import { EnvelopCircleIcon } from "../../../../styles/img/svg/EnvelopCircleIcon";
import { UiCustomPopup, UiPopup } from "../../component/common/UiModal";
import { PassbookIcon } from "../../../../styles/img/svg/PassbookIcon";
import { UiDashboardCardSlider } from "../../component/_uiComponents/UiDashboardCardSlider";
import { UiRightSideModal } from "../../component/common/UiRightSideModal";
import { AccountDetail } from "../../component/_uiComponents/Accounts/AccountDetail";
import { FundTransferIcon } from "../../../../styles/img/svg/FundTransferIcon";
import { UiTable } from "../../component/common/UiTable";
import {
  PassbookTableBody,
  PassbookTableHeaders,
} from "../../component/_uiComponents/UiMockData/PassbookTableData";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Paper,
  TableRow,
} from "@mui/material";
import { UiGrayBgLoaderWithMessage } from "../../component/common/UiGrayBgLoader";
import { ReloadIconDark } from "../../../../styles/img/svg/ReloadIconDark";

export const UiAccountInfoError = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openSideModal, setOpenSideModal] = useState(false);
  const [showPassbook, setShowPassbook] = useState(false);
  const [showMyAccounts, setShowMyAccounts] = useState(false);
  const [showMyCards, setShowMyCards] = useState(false);

  const handleCloseModal = () => setOpenModal(false);

  const handleOpenModal = () => setOpenModal(true);

  const tabList = [
    {
      id: 1,
      label: "Accounts",
      value: "1",
    },
    {
      id: 2,
      label: "Cards",
      value: "2",
    },
  ];

  return (
    <>
      <UiNavBar />
      <UiDashboardWrapper>
        <UiSideBar />
        <UiDashboardContent>
          <div className="df-db-left">
            <UiWhiteCard className="mt-0">
              <UiTab tabNav={tabList}>
                <TabPanel value="1">
                  <UiGrayBgLoaderWithMessage
                    className="df-act-hist-err m-0 df-pw-60"
                    loaderSize={40}
                    errorMessage="Sorry, we couldn't load your account information. Please tap to refresh.
"
                    icon={<ReloadIconDark />}
                  />

                  <UiActivities title="Latest activity for this account" />
                </TabPanel>

                <TabPanel value="2" className="df-card-tab">
                  <UiGrayBgLoaderWithMessage
                    className="df-act-hist-err m-0 df-pw-60"
                    loaderSize={40}
                    errorMessage="Sorry, we couldn't load your account information. Please tap to refresh.
"
                    icon={<ReloadIconDark />}
                  />
                  <UiActivities title="Latest activity for this card" />
                </TabPanel>
              </UiTab>
            </UiWhiteCard>
          </div>

          <div className="df-db-right">
            <UiNotificationCardWrapper
              icon={<CloseIcon />}
              title="You have mail!"
              name="See Details"
              className="mt-0"
            >
              <UiNotificationCard
                icon={<EnvelopCircleIcon />}
                title="Increase card limit"
                message="Request to increase credit card limit..."
                date="Dec 12, 2024 09.42 AM"
              />
            </UiNotificationCardWrapper>

            <div className="df-icon-card-wrapper">
              <UiWhiteCard className="df-icon-card">
                <TransferIcon />
                <h5>Transfer</h5>
              </UiWhiteCard>

              <UiWhiteCard className="df-icon-card">
                <BillIcon />
                <h5>Pay a Bill</h5>
              </UiWhiteCard>

              <UiWhiteCard className="df-icon-card">
                <SettleCardIcon />
                <h5>Settle a Card</h5>
              </UiWhiteCard>
            </div>

            <UiDashboardCardSlider />

            <UiWhiteCard className="df-play-again">
              <Grid container className="df-align-center mb-2">
                <Grid size={7}>
                  <h2 className="df-play-again__title">Pay Again</h2>
                </Grid>
                <Grid size={5} className="text-right">
                  <UiTextIconButton
                    icon={<BookmarkIcon />}
                    name="All Favourites"
                    className="df-primary-underlined-text-icon-btn"
                  />
                </Grid>
              </Grid>

              <UiFavouriteItem
                logo={Alogo}
                title="Ashan Fernando"
                description="A/C: 21930039100"
              />

              <UiFavouriteItem
                logo={DialogLogo}
                title="My Dialog 500"
                description="0777841608"
              />
              <UiFavouriteItem
                logo={Alogo}
                title="Ashan Fernando"
                description="A/C: 21930039100"
              />

              <UiFavouriteItem
                logo={DialogLogo}
                title="My Dialog 500"
                description="0777841608"
              />

              <UiFavouriteItem
                logo={Alogo}
                title="Ashan Fernando"
                description="A/C: 21930039100"
              />
            </UiWhiteCard>
          </div>
        </UiDashboardContent>
      </UiDashboardWrapper>

      <UiCustomPopup
        openModal={openModal}
        handleClose={handleCloseModal}
        showCloseIcon
        className="df-view-acc-actions-pp"
      >
        <div className="df-vertical-icon-card">
          <div className="df-vertical-icon-card__item">
            <div onClick={() => setShowPassbook(true)}>
              <PassbookIcon />
              <p>View Passbook</p>
            </div>
          </div>

          <div className="df-vertical-icon-card__item">
            <div>
              <FundTransferIcon />
              <p>Fund Transfer</p>
            </div>
          </div>

          <div className="df-vertical-icon-card__item">
            <div>
              <BillIcon />
              <p>Pay a Bill</p>
            </div>
          </div>
        </div>
      </UiCustomPopup>

      {/* passbook popup */}
      <UiCustomPopup
        openModal={showPassbook}
        handleClose={() => setShowPassbook(false)}
        showCloseIcon
        className="df-showpb-pp"
      >
        <div className="df-passbook">
          <h2 className="df-popup-title">Passbook</h2>
          <UiTable
            tableHeaders={PassbookTableHeaders}
            className="df-table df-passbook-table"
          >
            {PassbookTableBody.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.date}</TableCell>
                <TableCell>{row.description}</TableCell>
                {row.status === "low" ? (
                  <TableCell className="df-tb-warning">{row.amount}</TableCell>
                ) : (
                  <TableCell>{row.amount}</TableCell>
                )}

                <TableCell>{row.balance}</TableCell>
              </TableRow>
            ))}
          </UiTable>
        </div>
      </UiCustomPopup>

      {/* view account modal */}
      <UiRightSideModal
        openSideModal={openSideModal}
        handleClose={() => setOpenSideModal(false)}
      >
        <AccountDetail viewPassbook={() => setShowPassbook(true)} />
      </UiRightSideModal>
    </>
  );
};
